export default __webpack_public_path__ + "static/media/epl.d9ec808a.svg";